<app-service-detail>
    <app-variables-tabs primarySelectedTab="Tables" class="container-fluid px-5">
    </app-variables-tabs>
    <div class="row w-100 m-0 position-relative">

        <app-list-grid *ngIf="!hideList"
                       (updateFunction)="update($event)"
                       class="col-md-12 px-md-5 ml-auto"
                       [items]="documents"
                       [determinantMapById]="determinantMapById"
                       [toggleIcons]="false"
                       [navigationEdit]="false"
                       [expanded]="true"
                       (deleteFunction)="deleteRequirement($event)"
                       (editFunction)="loadRequirement($event)"
                       (sortFunction)="sortNotification($event)"
                       (filterBy)="onNewFilterBy($event)"
                       headingText="Documents available in the service"
                       [elementsNumber]="elementsNumber"
                       createNewText1Part="Select existing document or click on"
                       createNewText2Part="to create a new document">
            <button (click)="loadRequirement(false)"
               placement="left"
               aria-hidden="true"
               class="btn btn-sm btn-primary mr-1">{{ 'Add' | translate }}</button>
        </app-list-grid>

        <div *ngIf="showEdit || showAdd"
             class="layer half-layer col px-3"
             [ngStyle]="style"
             mwlResizable
             [enableGhostResize]="true"
             [resizeEdges]="{ bottom: false, right: false, top: false, left: true }"
             (resizeEnd)="onResizeEnd($event)"
             style="min-height:calc(100vh - 9.1rem);">
            <div class="moving">
                <document-edit [serviceId]="serviceId"
                               [requirement]="document"
                               [dragIcons]="false"
                               (formSubmit)="closeSlider()"
                               (editCancel)="closeLayers()"
                               class="w-100"></document-edit>
            </div>
        </div>
        <div class="shadow"></div>
        <div class="col">
            <tab-menu *ngIf="hideList"
                      [items]="documents">
            </tab-menu>
            <ng-content></ng-content>
        </div>
    </div>
</app-service-detail>
